import { Buffer } from "buffer";
const bcUname = process.env.REACT_APP_API_USERNAME;
const bcpwd = process.env.REACT_APP_API_PASSWORD;
const REACT_APP_COMPANY = process.env.REACT_APP_COMPANY;
const REACT_APP_API_DATA_URL = process.env.REACT_APP_API_DATA_URL;
const REACT_ACTIONS = process.env.REACT_APP_BIDDING_API_DATA_URL;

export const token = Buffer.from(`${bcUname}:${bcpwd}`, "utf8").toString(
  "base64",
);

export const prequalificationLines = `${REACT_APP_API_DATA_URL}prequalificationlines?${REACT_APP_COMPANY}`;
export const uOMApi = `${REACT_APP_API_DATA_URL}uOM?${REACT_APP_COMPANY}`;
export const vatGroupings = `${REACT_APP_API_DATA_URL}vatProductGroups?${REACT_APP_COMPANY}`;
export const currenciesApi = `${REACT_APP_API_DATA_URL}currencies?${REACT_APP_COMPANY}`;
export const countriesAPIs = `${REACT_APP_API_DATA_URL}countries?${REACT_APP_COMPANY}`;
export const paymentTermsApi = `${REACT_APP_API_DATA_URL}paymentTerms?${REACT_APP_COMPANY}`;
export const rfpLines = `${REACT_APP_API_DATA_URL}rFPLines?${REACT_APP_COMPANY}`;
export const Manufacturers = `${REACT_APP_API_DATA_URL}manufac?${REACT_APP_COMPANY}`;
export const bidLinesWithCompany = `${REACT_APP_API_DATA_URL}bidlines?${REACT_APP_COMPANY}`;
export const Brands = `${REACT_APP_API_DATA_URL}brands?${REACT_APP_COMPANY}`;
export const prequalificationLineswithoutcompany = `${REACT_APP_API_DATA_URL}prequalificationlines`;
export const bidLineswithoutcompany = `${REACT_APP_API_DATA_URL}bidlines`;
export const rfpLineswithoutcompany = `${REACT_APP_API_DATA_URL}rFPLines`;
export const prequalificationheader = `${REACT_APP_API_DATA_URL}prequalificationheader?${REACT_APP_COMPANY}`;
export const bidheader = `${REACT_APP_API_DATA_URL}bidheader?${REACT_APP_COMPANY}`;
export const itemPrequalifications = `${REACT_APP_API_DATA_URL}itemPrequalifications?${REACT_APP_COMPANY}`;
export const prequalificationheaderNoCompany = `${REACT_APP_API_DATA_URL}prequalificationheader`;
export const bidheaderNoCompany = `${REACT_APP_API_DATA_URL}bidheader`;
export const itemPrequalificationsNoCompany = `${REACT_APP_API_DATA_URL}itemPrequalifications`;
export const productCategories = `${REACT_APP_API_DATA_URL}productCategories?${REACT_APP_COMPANY}`;
export const DeleteBCLines = `${REACT_ACTIONS}DeleteAllLines?${REACT_APP_COMPANY}`;
export const submitPrequalification = `${REACT_ACTIONS}SubmitPrequalification?${REACT_APP_COMPANY}`;
export const submitBidLines = `${REACT_ACTIONS}SubmitBid?${REACT_APP_COMPANY}`;
export const companyDefault = REACT_APP_COMPANY;
